<template>
  <v-app>
    <Navbar v-if="['PageNotFound', 'ResetPass'].indexOf($route.name) == -1" />
      <v-main class="background">
        <router-view></router-view>
      </v-main>
      <FloatingButton></FloatingButton>
      <ContactPopUp v-model="contactCardState" />  
      <AuthPopUp v-model="loginCardState" />
    <Footer/>
  </v-app>
</template>

<script>
import FloatingButton from "@/components/system/FloatingButton";
import Navbar from "@/components/layout/navbar";
import AuthPopUp from "@/components/auth/AuthPopUp";
import ContactPopUp from "@/components/system/ContactPopUp";
import Footer from '@/components/layout/footer'
import { mapGetters, mapActions } from "vuex";

export default {
  name: 'App',

  components: {
    AuthPopUp,
    ContactPopUp,
    Navbar,
    Footer,
    FloatingButton,
  },
  created() {
    this.setTheme()
    // i18n.locale = this.language;
    if (this.darkState == true) {
      this.$vuetify.theme.dark = true;
    } else {
      this.$vuetify.theme.dark = false;
    }
  },
  data: () => ({
    //
  }),
  methods: {
    ...mapActions([
            
    ]),
    setTheme(){
      if (this.darkState == true) {
        this.$vuetify.theme.dark = true;
      } else {
        this.$vuetify.theme.dark = false;
      }
    },
  },
  computed: {
    ...mapGetters([
      "darkState",
      "loginCardState",
      "contactCardState",
      "language"]),
  },
};
</script>
